<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-appointment-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('views.rate_detail.add_appointment') }}</h4>
        </template>
        <template v-slot:body>
            <div class="form-group" v-show="errorMessage">
                <div class="alert alert-danger" style="margin: 0 10px;">
                    {{errorMessage}}
                </div>
            </div>
            <AppointmentForm @change="onChangeNewAppointment" :new-appointment-prop="newAppointment"></AppointmentForm>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewAppointment()">
                <i class="las la-check"></i>
                {{ $t('components.appointment.add_date') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import AppointmentForm from "../appointment/AppointmentForm";
    import {createAppointment} from "../../api";
    import ModalContainer from "./ModalContainer";
    import i18n from "../../i18n"
    export default {
        name: "AddAppointmentModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            rateId: {
                type: Number,
                default: 0
            }
        },
        data: () => {
            return {
                loading: false,
                newAppointment: {
                    date: null,
                    client_admin: null,
                    is_online: false,
                    notify: true,
                    repeat: false,
                    repeat_day_of_week: 0,
                    repeat_until_date: null,
                    location: null,

                },
                errorMessage: ""
            }
        },
        components: {ModalContainer, AppointmentForm},
        methods: {
            onChangeNewAppointment(newAppointment) {
                this.newAppointment = newAppointment;
            },
            async createNewAppointment() {
                this.errorMessage = "";

                this.loading = true;
                try {
                    await createAppointment(
                        this.rateId,
                        this.newAppointment.date,
                        this.newAppointment.client_admin,
                        this.newAppointment.is_online,
                        this.newAppointment.repeat,
                        this.newAppointment.repeat_day_of_week,
                        this.newAppointment.repeat_until_date,
                        this.newAppointment.location,
                        this.newAppointment.notify);

                    this.$emit('success-create-appointment');
                    this.loading = false;
                    this.$route.params.successMessage = i18n.t('components.appointment.added_success_single');
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            }
        }
    };
</script>
